module.exports = __webpack_public_path__ + "img/1563.19bfe7e0.gif";